import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { CLINIC } from "@/lib/api";

const WA_MESSAGE = "Hi Manasvi Dental Clinic, I would like to enquire about an appointment with Dr. Deepika Charan.";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  // Build wa.me link (digits only, remove + and spaces)
  const waNumber = (CLINIC.phone || "").replace(/[^0-9]/g, "");
  const waHref = `https://wa.me/${waNumber}?text=${encodeURIComponent(WA_MESSAGE)}`;

  if (!visible) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-fab-wrapper">
      {/* Tooltip / preview card */}
      {open && (
        <div className="bg-card border border-border rounded-2xl shadow-xl p-5 max-w-[280px] anim-fade-up" data-testid="whatsapp-preview">
          <div className="flex items-start justify-between gap-3 mb-2">
            <div>
              <div className="font-serif text-lg leading-tight">Chat on WhatsApp</div>
              <div className="text-xs text-muted-foreground mt-0.5">Typically replies in a few minutes</div>
            </div>
            <button onClick={() => setOpen(false)} className="text-muted-foreground hover:text-foreground" data-testid="whatsapp-close" aria-label="Close">
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="bg-muted/60 rounded-lg p-3 text-sm text-foreground/85 mb-3">{WA_MESSAGE}</div>
          <a href={waHref} target="_blank" rel="noopener noreferrer"
             className="block text-center w-full rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-medium py-2.5 text-sm transition-colors"
             data-testid="whatsapp-start-chat">
            Start Chat
          </a>
        </div>
      )}

      {/* Floating button */}
      <button
        onClick={() => setOpen(o => !o)}
        className="relative h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white shadow-lg grid place-items-center transition-transform hover:scale-105 active:scale-95"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-fab"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <MessageCircle className="w-6 h-6 relative" fill="currentColor" />
      </button>
    </div>
  );
}
